import { LicenceOrganisationRule } from "@/Common/Api/MedfarDictionaries/Dto/Responses/LicenceOrganisationRule";
import { LicenceOrganisationSpecialisation } from "@/Common/Api/MedfarDictionaries/Dto/Responses/LicenceOrganisationSpecialisation";
import { Locale } from "@/Common/Models/Localization/Locale";

class SpecialisationCategory {
    public Name: string;
    public Position: number;
}

class TitleAndSpecialtyModel {
    public licenceOrganisationRuleModel: LicenceOrganisationRule;
    public licenceOrganisationSpecialisationModel: LicenceOrganisationSpecialisation;
    public parentOrganisationRuleModel: LicenceOrganisationRule;
    public id: string;

    constructor(licenceOrganisationRule: LicenceOrganisationRule, licenceSpecialisation: LicenceOrganisationSpecialisation) {
        this.licenceOrganisationRuleModel = licenceOrganisationRule;
        this.licenceOrganisationSpecialisationModel = licenceSpecialisation;
        this.initId();
        this.InitParent();
    }

    public initId(): void {
        this.id = this.licenceOrganisationRuleModel ? this.licenceOrganisationRuleModel.Id : "";
        this.id += this.licenceOrganisationSpecialisationModel ? "_" + this.licenceOrganisationSpecialisationModel.Id : "";
    }

    public InitParent(): void {
        if (this.licenceOrganisationRuleModel?.ParentLicenceOrganisationId)
            this.parentOrganisationRuleModel = cacheStore.LicenceOrganisationRulesById[this.licenceOrganisationRuleModel.ParentLicenceOrganisationId];
    }

    public static isValid(specialtyModel: TitleAndSpecialtyModel): boolean {
        return specialtyModel.licenceOrganisationRuleModel != null;
    }

    public static getName(specialtyModel: TitleAndSpecialtyModel, includeOrg: boolean = false): string {
        const specialtyName = TitleAndSpecialtyModel.getLicenceOrganisationSpecialisationName(specialtyModel);
        const licenceRuleName = TitleAndSpecialtyModel.getLicenceOrganisationRuleName(specialtyModel);
        let name = "";

        if (specialtyName != "")
            name = `${specialtyName} (${licenceRuleName})`; // if (this.ParentOrganisationRuleModel != null)
        else
            name = licenceRuleName;

        // Add Organisation Code
        if (includeOrg && !IsNullOrWhiteSpace(specialtyModel.licenceOrganisationRuleModel?.Acronym))
            name += ` (${specialtyModel.licenceOrganisationRuleModel.Acronym})`;

        return name;
    }

    public static getNameFromAnyLanguage(specialtyModel: TitleAndSpecialtyModel, includeOrg: boolean = false): string {
        var specialityName = TitleAndSpecialtyModel.getSpecNameFromAnyLanguage(specialtyModel);
        var licenceRuleName = TitleAndSpecialtyModel.getOrganisationFromAnyLanguage(specialtyModel);

        let name = "";

        if (specialityName != "")
            name = `${specialityName} (${licenceRuleName})`; // if (this.ParentOrganisationRuleModel != null)
        else
            name = licenceRuleName;

        if (includeOrg && !IsNullOrWhiteSpace(specialtyModel.licenceOrganisationRuleModel?.Acronym))
            name += ` (${specialtyModel.licenceOrganisationRuleModel.Acronym})`;

        return name;
    }

    public static getCategory(specialtyModel: TitleAndSpecialtyModel): SpecialisationCategory {
        let tmpCategory = new SpecialisationCategory();

        if (specialtyModel.licenceOrganisationSpecialisationModel != null)
            tmpCategory.Name = TitleAndSpecialtyModel.getLicenceOrganisationSpecialisationName(specialtyModel);
        else if (specialtyModel.parentOrganisationRuleModel != null)
            tmpCategory.Name = LicenceOrganisationRule.getTitleName(specialtyModel.parentOrganisationRuleModel);
        else
            tmpCategory.Name = TitleAndSpecialtyModel.getLicenceOrganisationRuleName(specialtyModel);

        if (IsNullOrWhiteSpace(tmpCategory.Name))
            tmpCategory.Name = "-";

        specialtyModel.parentOrganisationRuleModel != null
            ? tmpCategory.Position = LicenceOrganisationRule.getPosition(specialtyModel.parentOrganisationRuleModel)
            : tmpCategory.Position = TitleAndSpecialtyModel.getLicenceOrganisationRulePosition(specialtyModel);

        return tmpCategory;
    }

    public static getLicenceOrganisationRulePosition(specialtyModel: TitleAndSpecialtyModel): number {
        return LicenceOrganisationRule.getPosition(specialtyModel.licenceOrganisationRuleModel);
    }

    public static getLicenceOrganisationRuleLicenceOrgCode(specialtyModel: TitleAndSpecialtyModel): string {
        return specialtyModel.licenceOrganisationRuleModel.LicenceOrganisationCode;
    }

    public static getLicenceOrganisationRuleName(specialtyModel: TitleAndSpecialtyModel): string {
        return LicenceOrganisationRule.getTitleName(specialtyModel.licenceOrganisationRuleModel);
    }

    public static getLicenceOrganisationSpecialisationName(specialtyModel: TitleAndSpecialtyModel): string {
        return LicenceOrganisationSpecialisation.getSpecialtyName(specialtyModel.licenceOrganisationSpecialisationModel);
    }

    public static getSpecNameFromAnyLanguage(specialtyModel: TitleAndSpecialtyModel): string {
        if (!specialtyModel.licenceOrganisationSpecialisationModel)
            return "";

        switch (sessionStore.locale) {
            case Locale.fr:
                return specialtyModel.licenceOrganisationSpecialisationModel.NameFr;
            case Locale.es:
                return specialtyModel.licenceOrganisationSpecialisationModel.NameEs;
            default:
                return specialtyModel.licenceOrganisationSpecialisationModel.NameEn;
        }
    }

    public static getOrganisationFromAnyLanguage(specialtyModel: TitleAndSpecialtyModel): string {
        return LicenceOrganisationRule.getNameFromAnyLanguage(specialtyModel.licenceOrganisationRuleModel);
    }
}

export { SpecialisationCategory, TitleAndSpecialtyModel };
